var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("ConsultantOrdersSubMenusLinks", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      isExternal: true
    }
  }), _c("div", {
    staticClass: "content-centered large"
  }, [_vm.isHolding(_vm.loggedUserData) && _vm.order ? _c("HoldingOrderSummary", {
    attrs: {
      baseModel: _vm.order,
      loggedUserData: _vm.loggedUserData
    }
  }) : _vm.isConsultantOrHolding(_vm.loggedUserData) && _vm.order ? _c("ConsultantOrderSummary", {
    attrs: {
      baseModel: _vm.order,
      loggedUserData: _vm.loggedUserData
    }
  }) : _vm.isDataLoading == false ? _c("Error", {
    attrs: {
      error: _vm.error
    }
  }) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };